document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll<HTMLElement>('.count-up');

  const countUp = (el) => {
    const target = parseInt(el.textContent, 10);
    const duration = 2000; // ms
    const steps = 60;
    const stepTime = duration / steps;
    let current = 0;

    el.textContent = '0';

    const timer = setInterval(() => {
      current += target / steps;
      if (current >= target) {
        el.textContent = target.toLocaleString('de-DE');
        clearInterval(timer);
      } else {
        el.textContent = Math.floor(current).toLocaleString('de-DE');
      }
    }, stepTime);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        countUp(entry.target);
        observer.unobserve(entry.target); // nur einmal zählen
      }
    });
  }, {
    threshold: 0.5 // Element muss zu 50% sichtbar sein
  });

  counters.forEach((counter) => observer.observe(counter));
});